let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bG4Tm")).then(() => parcelRequire('85Fev'));